module.exports = __webpack_public_path__ + "img/company-logo.4ca50559.png";